export default {
  lang: "Italiano",

  // Dextra Content
  welcome: "Consulenza video Dextra",
  s_services: "Servizi Dextra",
  s_tracking: "Monitoraggio servizi",
  s_record: "Servizi documenti",
  s_redirect: "Reindirizzamento servizio",
  s_adress: "Servizi indirizzo",
  s_feedback: "Supporto clienti",
  privacy: "La tua privacy è importante. Le conversazioni sono trattate confidenzialmente e non vengono registrate.",
  agentAvailability: "Disponibilità agente",
  available: "Disponibile",
  unavailable: "Non disponibile",
  connecting_title: "Connessione...",
  connecting_message: "Attendere un momento.",
  cancel: "Annulla",
  button_start: "Inizia qui"
}
